<main class="main-dashboard">
    <article class="main-canvas">
        <section class="canvas-container">
            <section class="dashboard-items">
                <div class="canvas-item">
                    <div class="canvas-header row justify-content-between align-items-center">
                        <div class="title col-sm-12">
                            <div class="d-flex align-items-center"> 
                                <div class="edit">
                                    <button title="back page" (click)="backToExit()">
                                    <span><i class="ri-arrow-left-line"></i></span>
                                    </button>
                                </div>
                                <div class="title col-sm-6">
                                    <h3 class="px-3"> Exit Process</h3>
                                </div>
                                <div *ngIf="this.isEmployeeFormVisible" class="col-sm-6 d-flex justify-content-end gap-2" style="display: flex; justify-content: flex-end; align-items: center;">
                                    <!-- <div [hidden]="hidePrintBtn">
                                        <button class="btn" id="printInterviewForm" (click)="printDivForm()"><i class="ri-printer-line" style="margin-right: 10px;"></i>Print Interview Form</button>
                                    </div> -->
                                    <div [hidden]="hidePrintBtn">
                                        <button class="btn" id="print" (click)="printDiv()"><i class="ri-printer-line" style="margin-right: 10px;"></i>Print</button>
                                    </div>
                                    <div>
                                        <button title="Create" type="button" (click)="ExitEmployeeForm()" class="btn">
                                            Employee Exit Interview Forms
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="canvas-header ">
                        <div class="title col-sm-12 d-flex">
                            <h3><a class="active cursor-pointer">User</a></h3>
                            <h3><a (click)="openDepartmentExit()" *ngIf="this.isEmployeeFormVisible" class="cursor-pointer">Department</a></h3>
                            <h3><a (click)="openItHrmExit()" *ngIf="this.isEmployeeFormVisible" class="cursor-pointer">IT</a></h3>
                            <h3><a (click)="openFinanceExit()" *ngIf="this.isEmployeeFormVisible" class="cursor-pointer">Finance</a></h3>
                            <h3><a (click)="openHrExit()" *ngIf="this.isEmployeeFormVisible" class="cursor-pointer">HR & Admin</a></h3>
                            <h3><a (click)="employeeAnknow()" class="cursor-pointer" *ngIf="this.isEmployeeFormVisible && this.isAckVisible">Employee AcKnowledge</a></h3>
                            <h3><a (click)="employeeAnknow()" class="cursor-pointer" *ngIf="this.isEmployeeFormVisible && this.isHRAdmin">Employee AcKnowledge</a></h3>
                        </div>
                        <!-- <div class="title col-sm-6 d-flex" *ngIf="!this.isVisible">
                            <h3><a class="active cursor-pointer">User</a></h3>
                            <h3><a (click)="employeeAnknow()" class="cursor-pointer">Employee Acknowledge</a></h3>
                        </div> -->
                    </div>
                    <div class="canvas-data">
                        <div class="row">
                            <div class="col-sm-12">
                                <h5>Personal Information</h5>
                            </div>
                        </div>
                        <div class="row">
                            <form [formGroup]="exitProcessForm">
                                <div class="row">
                                    <div class="col-sm-4">
                                        <div class="input">
                                            <div class="input-item">
                                                <input type="text" formControlName="localId">
                                                <label class="floating-label-special">Employee Id</label>
                                                <i class="ri-user-line"></i>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-4">
                                        <div class="input">
                                            <div class="input-item">
                                                <input type="text" formControlName="userId">
                                                <label class="floating-label-special">Full Name</label>
                                                <i class="ri-user-line"></i>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-4">
                                        <div class="input">
                                            <div class="input-item">
                                                <input type="date" formControlName="joiningDate">
                                                <label class="floating-label-special">Joining Date</label>
                                               <i class="ri-calendar-line"></i>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-4">
                                        <div class="input">
                                            <div class="input-item">
                                                <input type="text" formControlName="currentDesignation">
                                                <label class="floating-label-special">Designation</label>
                                                <i class="ri-user-line"></i>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-4">
                                        <div class="input">
                                            <div class="input-item">
                                                <input type="date" formControlName="resignationDate">
                                                <label class="floating-label-special">Resignation Date</label>
                                               <i class="ri-calendar-line"></i>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-4">
                                        <div class="input">
                                            <div class="input-item">
                                                <input type="text" formControlName="department">
                                                <label class="floating-label-special">Department</label>
                                                <i class="ri-user-line"></i>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-4">
                                        <div class="input">
                                            <div class="input-item">
                                                <input type="date" formControlName="expectedLastWorkingDate" disabled>
                                                <label class="floating-label-special">Expected Last Working Date</label>
                                               <i class="ri-calendar-line"></i>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-4">
                                        <div class="input">
                                            <div class="input-item" *ngIf="this.isDisabled">
                                                <input type="date" formControlName="lastWorkingDate" disabled>
                                                <label class="floating-label-special">Last Working Date</label>
                                               <i class="ri-calendar-line"></i>
                                            </div>
                                            <div class="input-item" *ngIf="!this.isDisabled">
                                                <input type="date" formControlName="lastWorkingDate">
                                                <label class="floating-label-special">Last Working Date</label>
                                               <i class="ri-calendar-line"></i>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-4">
                                        <div class="input">
                                            <div class="input-item">
                                                <select formControlName="status">
                                                    <option value="" disabled selected>Select Status</option>
                                                    <option value="Accepted" disabled>Accepted</option>
                                                    <option value="Submitted" *ngIf="this.exitStatus === 'Submitted'">Submitted</option>
                                                    <option value="Rejected" *ngIf="this.exitStatus === 'Accepted'" disabled>Rejected</option>
                                                    <option value="Withdrawn" *ngIf="this.exitStatus === 'Submitted'">Withdraw</option>
                                                </select>
                                                <label class="floating-label-special">Status</label>
                                                <i class="ri-user-line"></i>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-4 d-flex justify-content-between align-items-center">
                                        <button class="btn-secondary btn" (click)="backToExit()">Cancel</button>
                                        <button type="button" class="btn" (click)="updateUserSeperation()">Save</button>
                                    </div>
                            </div>
                            </form>
                            
                            <!-- <div class="col-sm-12" *ngIf="this.isEmployeeFormVisible">
                                <p>CLEARANCE FROM HR/ACCOUNTS/FINANCE</p>
                            </div>
                            <div class="col-sm-10 inner-details" *ngIf="this.isEmployeeFormVisible">
                                <table class="table">
                                    <thead class="h-90" style="border: 0; border-radius: 8px">
                                      <tr>
                                        <th>List of Activities</th>
                                        <th>Status</th>
                                        <th>Action With Team</th>
                                        <th></th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let item of userClearanceData">
                                            <td>
                                              {{ item.itemName }}
                                            </td>
                                            <td>
                                              {{ item.status }}
                                            </td>
                                            <td>
                                              {{ item.clearanceType }}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div> -->
                        </div>
                    </div>
                </div>
            </section>
        </section>

        <div class="card" style="display: none;">
            <div id="clearanceForm" class="clearance-form p-4">
                <div class="card-body">
                    <div class="p-3 mb-3">
                        <!-- Header -->
                        <table class="w-100 mb-4 border">
                            <tr>
                              <td style="width: 25%; text-align: center;">
                                <img *ngIf="this.isTenantCustomised" src="/assets/third-party-logo/imtecnology-logo.png" alt="Logo" style="max-width: 120px;" />
                                <img *ngIf="!this.isTenantCustomised" src="/assets/Pragamana_icon (3).jpg" alt="Logo" style="max-width: 120px;" />
                              </td>
                              <td style="width: 50%; text-align: center; border-left: 1px solid #000;">
                                <h2 style="margin: 0;">Employee <br /> Clearance Form</h2>
                              </td>
                              <td *ngIf="this.isTenantCustomised" style="width: 25%; font-size: 14px; border-left: 1px solid #000;">
                                <b>Doc Number:</b> IMT/HR-EC/01<br />
                                <b>Version:</b> 2.0<br />
                                <b>Last Modified:</b> 02/07/2024<br />
                                <b>Department:</b> HR
                              </td>
                              <td *ngIf="!this.isTenantCustomised" style="width: 25%; font-size: 14px; border-left: 1px solid #000;">
                                <b>Doc Number:</b> Pragamana<br />
                                <b>Department:</b> HR
                              </td>
                            </tr>
                        </table>


                        <!-- Personal Info Table -->
                        <table class="table table-bordered w-100 mb-4">
                            <tr>
                            <td><b>Name:</b></td>
                            <td>{{ this.userSeperationDataObj?.userName }}</td>
                            <td><b>Emp ID:</b></td>
                            <td>{{ this.userSeperationDataObj?.localId }}</td>
                            </tr>
                            <tr>
                            <td><b>Joining Date:</b></td>
                            <td>{{ this.userSeperationDataObj?.dateOfJoining}}</td>
                            <td><b>Resignation Date:</b></td>
                            <td>{{ this.userSeperationDataObj?.resignationDate}}</td>
                            </tr>
                            <tr>
                            <td><b>Designation:</b></td>
                            <td>{{ this.userSeperationDataObj?.currentDesignation }}</td>
                            <td><b>Relieving Date:</b></td>
                            <td>{{ this.userSeperationDataObj?.lastWorkingDate }}</td>
                            </tr>
                            <tr>
                            <td><b>Dept/Project:</b></td>
                            <td>{{ this.userSeperationDataObj?.department }}</td>
                            <td><b>Personal Contact Number:</b></td>
                            <td>{{ this.userSeperationDataObj?.alternateContactNo }}</td>
                            </tr>
                            <tr>
                            <td><b>Personal Email Id:</b></td>
                            <td colspan="3">{{ this.userSeperationDataObj?.alternateEmailId }}</td>
                            </tr>
                        </table>
                    
                        <!-- Clearance from Reporting Manager -->
                        <h5 class="text-center text-uppercase mb-3 mt-4"><u>Clearance from Reporting Manager</u></h5>

                        <!-- Clearance Table -->
                        <table class="table table-bordered w-100">
                            <thead>
                            <tr>
                                <th style="width: 5%;">Sr. No.</th>
                                <th>List of Activities</th>
                                <th>Status</th>
                                <th>(Pending/ Completed)</th>
                            </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let item of reportingManagerClearanceData; let i = index">
                                    <td>{{ i + 1 }}</td>
                                    <td>{{ item.itemName }}</td>
                                    <td>{{ item.status || '-' }}</td>
                                    <td>{{ item.extraColumn1 || '-' }}</td>
                                  </tr>
                            </tbody>
                        </table>

                        <!-- Final Status -->
                        <div class="mt-4">
                            <strong>Clearance From Reporting Manager:</strong>
                            <span style="margin-left: 20px;">
                                <span *ngIf="isManagerCleared === 'Yes'" class="badge badge-success">Yes</span>
                                <span *ngIf="isManagerCleared === 'No'" class="badge badge-danger">No</span>
                                <span *ngIf="!isManagerCleared">-</span>
                            </span>
                        </div>

                        <!-- Clearance from Reporting Manager -->
                        <h5 class="text-center text-uppercase mb-3 mt-4"><u>Clearance from Accounts & Finance</u></h5>

                        <!-- Clearance Table -->
                        <table class="table table-bordered w-100">
                            <thead>
                            <tr>
                                <th style="width: 5%;">Sr. No.</th>
                                <th>List of Activities</th>
                                <th>Remarks</th>
                                <th>Signature</th>
                            </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let item of financeAdminClearanceData; let i = index">
                                    <td>{{ i + 1 }}</td>
                                    <td>{{ item.itemName }}</td>
                                    <td>{{ item.status || '-' }}</td>
                                    <td>{{ item.extraColumn1 || '-' }}</td>
                                  </tr>
                            </tbody>
                        </table>

                        <!-- Final Status -->
                        <div class="mt-4">
                            <strong>Clearance From Finance:</strong>
                            <span style="margin-left: 20px;">
                                <span *ngIf="financeAdminCleared === 'Yes'" class="badge badge-success">Yes</span>
                                <span *ngIf="financeAdminCleared === 'No'" class="badge badge-danger">No</span>
                                <span *ngIf="!financeAdminCleared">-</span>
                            </span>
                        </div>

                        <!-- Clearance from Reporting Manager -->
                        <h5 class="text-center text-uppercase mb-3 mt-4"><u>Clearance from IT</u></h5>

                        <!-- Clearance Table -->
                        <table class="table table-bordered w-100">
                            <thead>
                            <tr>
                                <th style="width: 5%;">Sr. No.</th>
                                <th>List of Activities</th>
                                <th>Status</th>
                                <th>Remarks</th>
                            </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let item of itAdminClearanceData; let i = index">
                                    <td>{{ i + 1 }}</td>
                                    <td>{{ item.itemName }}</td>
                                    <td>{{ item.status || '-' }}</td>
                                    <td>{{ item.extraColumn1 || '-' }}</td>
                                  </tr>
                            </tbody>
                        </table>

                        <!-- Final Status -->
                        <div class="mt-4">
                            <strong>Clearance From IT:</strong>
                            <span style="margin-left: 20px;">
                                <span *ngIf="itAdminCleared === 'Yes'" class="badge badge-success">Yes</span>
                                <span *ngIf="itAdminCleared === 'No'" class="badge badge-danger">No</span>
                                <span *ngIf="!itAdminCleared">-</span>
                            </span>
                        </div>


                        <!-- Clearance from Reporting Manager -->
                        <h5 class="text-center text-uppercase mb-3 mt-4"><u>Clearance from HR & Admin</u></h5>

                        <!-- Clearance Table -->
                        <table class="table table-bordered w-100">
                            <thead>
                            <tr>
                                <th style="width: 5%;">Sr. No.</th>
                                <th>List of Activities</th>
                                <th>Status</th>
                                <th>Remarks</th>
                            </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let item of hrAdminClearanceData; let i = index">
                                    <td>{{ i + 1 }}</td>
                                    <td>{{ item.itemName }}</td>
                                    <td>{{ item.status || '-' }}</td>
                                    <td>{{ item.extraColumn1 || '-' }}</td>
                                  </tr>
                            </tbody>
                        </table>

                        <!-- Final Status -->
                        <div class="mt-4">
                            <strong>Clearance From HR & Admin:</strong>
                            <span style="margin-left: 20px;">
                                <span *ngIf="hrAdminCleared === 'Yes'" class="badge badge-success">Yes</span>
                                <span *ngIf="hrAdminCleared === 'No'" class="badge badge-danger">No</span>
                                <span *ngIf="!hrAdminCleared">-</span>
                            </span>
                        </div>

                        <!-- Clearance from Reporting Manager -->
                        <h5 class="text-center text-uppercase mb-3 mt-4"><u>Acknowledgment by Employee</u></h5>

                        <!-- Clearance Table -->
                        <table class="table table-bordered w-100">
                            <tbody>
                                <tr>
                                    <p>
                                        I, <b>{{this.userSeperationDataObj?.userName}}</b> Acknowledge that i have returned all company property,completed the necessary clearance 
                                            procedures and have no outstanding dues or obligations. I also accept any recoveries or 
                                            deductions menstioned as part of clearance process.
                                    </p>
                                    {{this.userSeperationDataObj?.userName}}
                                    <br>Date: {{this.dateOfAck}}
                                </tr>
                            </tbody>
                        </table>


                        <!-- Clearance from Reporting Manager -->
                        <h5 class="text-center text-uppercase mb-3 mt-4"><u>Document Status</u></h5>

                        <!-- Clearance Table -->
                        <table class="table table-bordered w-100">
                            <tbody>
                                <tr *ngFor="let item of miscData; let i = index">
                                    <td>{{ item.itemName }}</td>
                                    <td>{{ item.status || '-' }}</td>
                                    <td>{{ item.extraColumn1 || '-' }}</td>
                                </tr>
                            </tbody>
                        </table>

                    </div>
                </div>
            </div>
        </div>

        <div class="card" style="display: none;">
            <div id="exitInterviewForm" class="clearance-form p-4">
                <div class="card-body">
                    <div class="p-3 mb-3">
                        <!-- Header -->
                        <table class="w-100 mb-4 border">
                            <tr>
                              <td style="width: 25%; text-align: center;">
                                <img *ngIf="this.isTenantCustomised" src="/assets/third-party-logo/imtecnology-logo.png" alt="Logo" style="max-width: 120px;" />
                                <img *ngIf="!this.isTenantCustomised" src="/assets/Pragamana_icon (3).jpg" alt="Logo" style="max-width: 120px;" />
                              </td>
                              <td style="width: 50%; text-align: center; border-left: 1px solid #000;">
                                <h2 style="margin: 0;">Employee <br /> Exit Interview Form</h2>
                              </td>
                              <td *ngIf="this.isTenantCustomised" style="width: 25%; font-size: 14px; border-left: 1px solid #000;">
                                <b>Doc Number:</b> IMT/HR-EC/01<br />
                                <b>Version:</b> 1.0<br />
                                <b>Last Modified:</b> 22/02/2022<br />
                                <b>Department:</b> Internal
                              </td>
                              <td *ngIf="!this.isTenantCustomised" style="width: 25%; font-size: 14px; border-left: 1px solid #000;">
                                <b>Doc Number:</b> Pragamana<br />
                                <b>Department:</b> Internal
                              </td>
                            </tr>
                        </table>

                        <h5 class="text-center text-uppercase mb-3 mt-4"><u>EMPLOYEE EXIT INTERVIEW FORM</u></h5>
                    
                        <table class="table table-bordered w-100">
                            <tbody>
                                <tr>
                                    <p>
                                        <br />
                                        You worked with us & have contributed your share towards this organization. We appreciate your
                                        services & are interested in having your views towards the company & your colleagues, during
                                        your tenure with us.
                                    </p>
                                    <p>
                                        We value your honest, objective & unbiased views on the following issues. We assure you that
                                        sharing this information with others would be kept anonymous & used to increase our
                                        commitment towards being a fair organization.
                                        <br />
                                    </p>
                                    <hr style="border: dotted;"/>
                                    <br />
                                </tr>
                                <tr>
                                    <td>Mr/Ms: {{ this.userSeperationDataObj?.userName }}</td>
                                    <td>Id No: {{ this.userSeperationDataObj?.localId }}</td>
                                    <td>Last Working Day: {{ this.userSeperationDataObj?.lastWorkingDate }}</td>
                                </tr>
                                <tr>
                                    <td>Designation: {{ this.userSeperationDataObj?.currentDesignation }}</td>
                                    <td>Department: {{ this.userSeperationDataObj?.department }}</td>
                                    <td>Date of Joining: {{ this.userSeperationDataObj?.dateOfJoining }}</td>
                                </tr>
                                <tr>
                                    <td>Dept/Project name: {{ this.userSeperationDataObj?.department }}</td>
                                    <td>Reporting Manager name: {{ this.userSeperationDataObj?.reportingManager }}</td>
                                    <td>Location: {{ this.userSeperationDataObj?.location }}</td>
                                </tr>
                            </tbody>
                        </table>

                        <h5 class="text-center text-uppercase mb-3 mt-4"><u>INTERVIEW FORM</u></h5>

                        <!-- INTERVIEW FORM -->
                        <table class="table table-bordered w-100">
                            <tbody>
                                <tr>
                                    1. What was your principal reason for leaving the Job?*
                                    <br />
                                    A. {{ this.empInterviewDataObj?.mainReasonForLeavingCurrentJob }}
                                    <br /><br />
                                </tr>
                                <tr>
                                    2. Please Indicate the main reason for accepting other employment*
                                    <br />
                                    A. {{ this.empInterviewDataObj?.mainReasonForAcceptingOtherJob }}
                                    <br /><br />
                                </tr>
                                <tr>
                                    3. Please Indicate the main reason for accepting other employment*
                                    <br />
                                    A. {{ this.empInterviewDataObj?.mostLiked }}
                                    <br /><br />
                                </tr>
                                <tr>
                                    4. Please Indicate the main reason for accepting other employment*
                                    <br />
                                    A. {{ this.empInterviewDataObj?.leastLiked }}
                                    <br /><br />
                                </tr>
                                <tr>
                                    4. Would you like to recommend a family member/friend/ex-colleague for an appropriate position here?
                                    <br />
                                    A. {{ this.empInterviewDataObj?.anyReference }}
                                    <br />
                                </tr>
                            </tbody>
                        </table>

                        <!-- Clearance from Reporting Manager -->
                        <h5 class="text-center text-uppercase mb-3 mt-4"><u>Form 2:</u></h5>
                        <h5 class="mb-3 mt-4">Please complete the following picks</h5>

                        <!-- Form 2 -->
                        <table class="table w-100">
                            <tbody>
                                <tr>
                                    <td>1. I had regular feedback on my performance</td>
                                    <td>: {{ this.empInterviewDataObj2?.regularFeedback }}</td>
                                </tr>
                                <tr>
                                    <td>2. The policies and welfare benefits were fair</td>
                                    <td>: {{ this.empInterviewDataObj2?.policiesAndWelfareAreFair }}</td>
                                </tr>
                                <tr>
                                    <td>3. I am paid fairly for the work I do </td>
                                    <td>: {{ this.empInterviewDataObj2?.fairlyPaid }}</td>
                                </tr>
                                <tr>
                                    <td>4. There is scope for personal development & growth</td>
                                    <td>: {{ this.empInterviewDataObj2?.personalDevelopmentAndGrowthScope }}</td>
                                </tr>
                                <tr>
                                    <td>5. I had a good working relationship with my supervisor</td>
                                    <td>: {{ this.empInterviewDataObj2?.workingRelationshipWithManager }}</td>
                                </tr>
                                <tr>
                                    <td>6. I had a good working relationship with co-workers</td>
                                    <td>: {{ this.empInterviewDataObj2?.workingRelationshipWithCoworkers }}</td>
                                </tr>
                                <tr>
                                    <td>7. Training & job development met expectations</td>
                                    <td>: {{ this.empInterviewDataObj2?.trainingsMetExpectations }}</td>
                                </tr>
                                <tr>
                                    <td>8. Working conditions met expectations</td>
                                    <td>: {{ this.empInterviewDataObj2?.workingCOnditionMetExpectation }}</td>
                                </tr>
                                <tr>
                                    <td>9. The work culture in the Organization was good</td>
                                    <td>: {{ this.empInterviewDataObj2?.companyWorkCulture }}</td>
                                </tr>
                                <tr>
                                    <td>10. Overall I was satisfied with the job</td>
                                    <td>: {{ this.empInterviewDataObj2?.satisfactionWithJob }}</td>
                                </tr>
                            </tbody>
                        </table>

                        <div>
                            <span>
                                Q. What other comments/suggestions would you like to make ?
                                <br />
                                A. {{ this.empInterviewDataObj2?.commentsOrSuggestions }}
                                <br /><br />
                            </span>
                        </div>

                        <div>
                            <span>
                                <br />
                                Signature: 
                                <br /><br />
                                Date: 
                                <br /><br />
                            </span>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </article>
</main>